module.exports = __webpack_public_path__ + "img/logo-risq.8b00a3d5.png";